import React from 'react'
import { Loader2 } from 'lucide-react'

import { renderField } from 'src/features/RenderFieldForContactsUpdateWindow'

import { useAlertContactUpdateWindow } from 'src/features/AlertContactUpdateWindow/useAlertContactUpdateWindow'
import { AlertContactUpdateWindowProps } from 'src/features/AlertContactUpdateWindow/types'
import { ScrollArea } from 'src/components/shadcn/scroll-area'
import { Button } from 'src/components/shadcn/button'
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from 'src/components/shadcn/alert-dialog'

export const AlertContactUpdateWindow = ({
  itemId,
  isOpen,
  toggle,
  contactName,
  phoneNumber,
  serviceType,
  address,
  additionalNotes,
  onSave,
}: AlertContactUpdateWindowProps) => {
  const {
    title,
    cancel,
    updateBtn,
    fields,
    errors,
    control,
    isLoadingGeneral,
    handleSubmit,
    onUpdate,
  } = useAlertContactUpdateWindow({
    itemId,
    toggle,
    contactName,
    phoneNumber,
    serviceType,
    address,
    additionalNotes,
    onSave,
  })

  return (
    <form onSubmit={handleSubmit(onUpdate)}>
      <AlertDialog open={isOpen}>
        <AlertDialogContent className="max-h-[100svh] overflow-y-auto">
          <AlertDialogHeader>
            <AlertDialogTitle className="text-center">{title}</AlertDialogTitle>
          </AlertDialogHeader>
          <AlertDialogDescription>
            <ScrollArea className="h-[80svh] md:h-[65svh] w-full">
              {fields.map(
                ({ id, label, placeholder, type, validation, options }) => (
                  <div key={id}>
                    <h1 className="text-lg font-medium mb-2 mt-2">{label}</h1>
                    {renderField({
                      id,
                      label,
                      placeholder,
                      type,
                      validation,
                      options,
                      control,
                    })}
                    {errors[id] && (
                      <p className="text-red-500 text-sm mt-1">
                        {String(errors[id]?.message)}
                      </p>
                    )}
                  </div>
                ),
              )}
            </ScrollArea>
          </AlertDialogDescription>
          <AlertDialogFooter>
            <AlertDialogCancel
              className="rounded-[10px]"
              type="button"
              onClick={toggle}
            >
              {cancel}
            </AlertDialogCancel>
            <Button className="rounded-[10px]" onClick={onUpdate}>
              {isLoadingGeneral ? (
                <Loader2 className="animate-spin" size={13} />
              ) : (
                updateBtn
              )}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </form>
  )
}
